import React, { forwardRef } from 'react';

import { tw } from '../../utils/tailwind';
import {
  AlignObject,
  AlignProps,
  convertChackraAlignToTailwindClass,
  convertChackraJustifyToTailwindClass,
  convertChackraResponsiveValueToTailwindClass,
  FlexObject,
  FlexProps,
  JustifyObject,
  JustifyProps,
} from './utils';

export type IFlex = JSX.IntrinsicElements['div'] & {
  direction?: FlexProps | FlexObject;
  align?: AlignProps | AlignObject;
  justify?: JustifyProps | JustifyObject;
}

export const Flex: FCWithClassName<IFlex> = forwardRef(({
  children,
  direction,
  align,
  justify,
  className,
  style,
  'aria-label': ariaLabel,
  id,
  ...rest
}, forwardedRef) => {
  const tailwindFlexDirectionClasses =
    convertChackraResponsiveValueToTailwindClass(direction);
  const tailwindAlignClasses = convertChackraAlignToTailwindClass(align);
  const tailwindJustifyClasses = convertChackraJustifyToTailwindClass(justify);
  return (
    <div
      className={tw(
        'flex',
        tailwindFlexDirectionClasses,
        tailwindAlignClasses,
        tailwindJustifyClasses,
        className
      )}
      style={style}
      aria-label={ariaLabel}
      id={id}
      ref={forwardedRef}
      {...rest}
    >
      {children}
    </div>
  );
});

Flex.displayName = 'Flex';
